import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {
  transformDate(stringDate: string = '') {
    const splitdate = stringDate.split('/');
    let date = new Date(
      parseInt(splitdate[2]),

      parseInt(splitdate[1]) - 1,

      parseInt(splitdate[0])
    );
    return date;
  }
}
